import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { FaStamp, FaShoppingCart, FaTruck, FaHeadset } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import "../Style/Services.css";

const Services = () => {
  const { t } = useTranslation();

  return (
    <section id="services" className="py-5 bg-light">
      <Container>
        <h2 className="text-center mb-4 fw-bold">{t("Our Services")}</h2>
        <p className="text-center text-muted mb-5">
          {t(
            "We provide premium stamp selling services with excellent quality, secure shipping, and customer support. Here’s what we offer:"
          )}
        </p>
        <Row>
          {/* Service 1 */}
          <Col md={3} sm={6} className="mb-4">
            <Card className="h-100 shadow-sm border-0 text-center service-card">
              <Card.Body>
                <FaStamp size={40} className="text-primary mb-3" />
                <Card.Title>{t("Premium Stamps")}</Card.Title>
                <Card.Text>
                  {t(
                    "Explore our collection of rare and premium stamps with guaranteed authenticity."
                  )}
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>

          {/* Service 2 */}
          <Col md={3} sm={6} className="mb-4">
            <Card className="h-100 shadow-sm border-0 text-center service-card">
              <Card.Body>
                <FaShoppingCart size={40} className="text-success mb-3" />
                <Card.Title>{t("Easy Ordering")}</Card.Title>
                <Card.Text>
                  {t(
                    "Shop your favorite stamps easily with a user-friendly ordering system."
                  )}
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>

          {/* Service 3 */}
          <Col md={3} sm={6} className="mb-4">
            <Card className="h-100 shadow-sm border-0 text-center service-card">
              <Card.Body>
                <FaTruck size={40} className="text-warning mb-3" />
                <Card.Title>{t("Secure Shipping")}</Card.Title>
                <Card.Text>
                  {t(
                    "We ensure safe and timely delivery of stamps right to your doorstep."
                  )}
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>

          {/* Service 4 */}
          <Col md={3} sm={6} className="mb-4">
            <Card className="h-100 shadow-sm border-0 text-center service-card">
              <Card.Body>
                <FaHeadset size={40} className="text-danger mb-3" />
                <Card.Title>{t("24/7 Support")}</Card.Title>
                <Card.Text>
                  {t(
                    "Our support team is available anytime to assist with your stamp orders."
                  )}
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Services;
